'use client';

import type { ReactNode } from 'react';
import type { UniswapV3Adapter } from '../../data/mock-adapters';
import { AdapterPanelShell, Stat, StatGrid2 } from './AdapterPanelShell';
import { pairToCoinSymbol } from './pair-utils';

/**
 * Uniswap v3 LP adapter panel.
 *
 * Mirrors the Flaunch panel's 2-stat layout (TVL + Coin) so every
 * adapter card reads with the same shape — only the brand icon and
 * the underlying yield mechanic change. The previous 6-stat grid
 * (Fee / APR / TVL / Range / Tick / Accrued) gave the card a "trade
 * the LP" framing that competed with the adapter's actual purpose
 * (fund seat rewards); fee tier / tick range / range-mode now live
 * on the linked Uniswap pool page where they belong, and the
 * Accrued column was retired alongside Flaunch's for the same
 * "duplicates RewardsPanel" reason.
 *
 * `Coin` extracts the non-base symbol from the pair so Uniswap
 * cards read "TAKEOVER" / "USDC" / etc. rather than the full
 * `TAKEOVER / WETH` slash form — matching the bare-symbol Coin
 * column on the Flaunch panel.
 */
export function UniswapV3AdapterPanel({
  adapter,
  belowStats,
}: {
  adapter: UniswapV3Adapter;
  belowStats?: ReactNode;
}) {
  return (
    <AdapterPanelShell
      adapter={{ ...adapter, label: adapter.label ?? `Uniswap v3 · ${adapter.pair}` }}
      belowStats={belowStats}
    >
      <StatGrid2>
        <Stat label="TVL" value={adapter.tvlUsd} />
        <Stat label="Coin" value={pairToCoinSymbol(adapter.pair)} />
      </StatGrid2>
    </AdapterPanelShell>
  );
}
